import type { FaireProductEntity } from "../../entity_types/product";

export const p_dcfkdacenq: FaireProductEntity = {
  token: "p_dcfkdacenq",
  type: "product",
  name: "Hush The Rush Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/8b7795b0446c839dab2f3f38de42e5f191eb0764c0e629cdc6a2c657ed915968.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4650f2e2a69f351b5838bac2d1b54f5d70562df5b3f4721387a10bc86ebf186.jpeg",
    "https://cdn.faire.com/fastly/81714b27410d08d0557c10f8ab221eeb7653689de240db786e5df8f42f06ff8f.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying an inspirational sentiment reads \"Hush The Rush\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our Hush The Rush metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:31.087Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
